  <mat-form-field class="filter-search-box-container">
    <mat-label>Sök</mat-label>
    <input matInput type="text" [formControl]="filterText" autocomplete="off">
    <mat-icon matTextPrefix>search</mat-icon>

    <button *ngIf="filterText.value" matSuffix mat-icon-button aria-label="Rensa söktext" (click)="onFilterClear()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
